module.exports = __webpack_public_path__ + "img/megalurothrips-usitatus.66763d20.jpg";